import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import illu from "./../../assets/images/illu/About.jpg";

const About = () => {
  return (
    <section className="About-container" id="about">
      <img className="img-illu" src={illu} alt="illustration" />
      <article className="About-text">
        <h2>
          JPP COMPTA : <br />
          <span className="blue">
            Le partenaire
            <br />
          </span>
          comptable des
          <span className="blue"> entrepreneurs</span> d’aujourd’hui.
        </h2>
        <p>
          On est bien plus qu’un cabinet comptable : on est votre copilote
          entrepreneurial. Chez JPP COMPTA, notre mission est simple : vous
          aider à comprendre vos chiffres pour les mettre au service de vos
          rêves. Avec nous, la compta devient claire, fluide et même agréable
          (oui, c’est possible).
        </p>
        <Link to="#contact" className="btn">
          Contact <svg xmlns="http://www.w3.org/2000/svg" className="arrow-icon white" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
        </Link>
      </article>
    </section>
  );
};

export default About;
